import { css } from "styled-components";

export const compactShipmentCardStyles = css`
  .content-container {
    position: relative;
    border: 1px solid ${({ theme }) => theme.mainBorderColor};
    border-radius: 12px;
    box-shadow: 0 4px 14px rgba(20, 24, 32, 0.045);
    transition: transform 160ms ease, border-color 160ms ease, box-shadow 160ms ease;

    &:hover {
      transform: translateY(-1px);
      border-color: rgba(232, 84, 70, 0.38);
      box-shadow: 0 7px 20px rgba(20, 24, 32, 0.07);
    }

    .content-wrapper {
      gap: 18px;
      margin-bottom: 26px;
    }

    .content-column {
      min-width: 0;
      gap: 6px;
    }

    .content-item {
      min-width: 0;
      line-height: 1.4;
      overflow-wrap: anywhere;
    }

    .copy-field {
      margin-bottom: 2px;
      font-size: var(--font-size-sm);
      font-weight: var(--font-weight-md);
    }

    .absolute-id {
      position: absolute;
      bottom: 0;
      left: 0;
      align-self: auto;
      width: auto;
      min-width: 72px;
      padding: 4px 8px;
      border: 0;
      border-radius: 0 7px 0 10px;
      background: var(--color-main);
      color: #fff;

      .copy-label {
        color: rgba(255, 255, 255, 0.78);
      }
    }
  }

  @media (max-width: 1350px) {
    .content-container {
      .content-wrapper {
        gap: 12px;
      }

      .content-item {
        font-size: 12px;
      }
    }
  }
`;

export const wideShipmentCardStyles = css`
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding-bottom: 28px;
  border: 1px solid ${({ theme }) => theme.mainBorderColor};
  border-radius: 12px;
  box-shadow: 0 6px 20px rgba(20, 24, 32, 0.055);

  .content-side,
  .main-content {
    width: 100%;
  }

  .content-container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }

  .content-container .main-content {
    width: 100%;
  }

  .content-side {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: start;
    gap: 14px;
    margin: 0;
    padding: 20px 20px 8px;
  }

  .content-side .column-container {
    width: 100%;
    min-width: 0;
    gap: 18px;
    padding: 15px;
    border: 1px solid ${({ theme }) => theme.mainBorderColor};
    border-radius: 9px;
    background: rgba(127, 127, 127, 0.025);
  }

  .content-side .column-container .column-item {
    min-height: auto;
  }

  .main-content {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    align-items: start;
    gap: 14px;
    padding: 20px 20px 8px;
  }

  .content-container .main-content > .roads,
  .content-container .main-content > .others {
    min-width: 0;
    width: 100%;
    padding: 15px;
    border: 1px solid ${({ theme }) => theme.mainBorderColor};
    border-radius: 9px;
    background: rgba(127, 127, 127, 0.025);
  }

  .column-item-title,
  .content-column p {
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(232, 84, 70, 0.48);
  }

  .copy-field {
    margin-bottom: 4px;
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-md);
  }

  .absolute-id {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 3;
    width: auto;
    min-width: 72px;
    padding: 4px 8px;
    border: 0;
    border-radius: 0 7px 0 10px;
    background: var(--color-main);
    color: #fff;

    .copy-label {
      color: rgba(255, 255, 255, 0.78);
    }
  }

  .tracking-history {
    grid-column: 1 / 3;
    width: 100%;
    margin: 0;
    padding: 14px 15px 8px;
    border: 1px solid ${({ theme }) => theme.mainBorderColor};
    border-radius: 9px;
    background: rgba(127, 127, 127, 0.025);
  }

  .wide-actions {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 8px;
    width: 100%;
    padding: 6px 20px 20px;
  }

  @media (max-width: 1200px) {
    .content-side,
    .content-container .main-content {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .tracking-history {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 900px) {
    .content-side,
    .content-container .main-content {
      grid-template-columns: 1fr;
      padding: 14px 14px 6px;
    }

    .wide-actions {
      justify-content: stretch;
      padding: 6px 14px 16px;

      button {
        flex: 1 1 180px;
      }
    }
  }
`;
